import { addProduct } from "../Containers/DonationView/slice";

import { SupportEmail } from "./enum";

export const EnglishTranslations = {
  logintitle: "Welcome back! Come fight food waste",
  registerTitle: "Come fight food waste",
  loginbutton: "Login",
  loginDescription:
    "In that time, indeed, there is no resultant or wise man. All modes of error. They abandon the system as a result of the film, which they did not do. Aceder",
  authOptions: "Alternate access",
  rememberMe: "keep me logged in",
  forgotPassword: "Regain Access",
  dontHaveAccount: "Not registered yet?",
  createAccount: "Create an account",
  password: "Password",
  register: "Register",
  confirmPassword: "Confirm Password",
  haveAccount: "Already registered?",
  loginWith: "Login with your account",
  profile: "Profile",
  activity: "Activity",
  entityType: "Entity Type",
  entityData: "Entity Data",
  platform: "Platform",
  cancel: "Cancel",
  approve: "Confirm reservation",
  profileQuestion: "How do you intend to use the platform?",
  activityQuestion: "What area of activity do you belong to?",
  entityTypeQuestion: "How do you characterize your entity?",
  entityDataQuestion: "Identification of your entity",
  platformQuestion: "Don't be left out, stay on top of everything",
  platformNotification: "Platform notifications (recommended)",
  platformNotificationSub: "Update messages, automatic operations",
  platformUserMessage: "User messages",
  platformDescription:
    "You can change the options later by going to your profile page.",
  platformConfirmation: "I confirm that I have read and accepted the",
  termsAndConditions: "Terms and Conditions",
  donor: "I want to donate",
  distributor: "I want to receive, distribute",
  donorDistributor: "I want to donate, receive, distribute",
  SubTitleSpecialDist : "Para alimentação animal...Quero receber produtos de doações que não foram reservadas – Todos os produtos inseridos na Plataforma que não foram reservados e atingiram a validade final do ticket, podem ser encaminhados para alimentação animal. Caso seja uma entidade com a missão / na área de proteção / cuidado de animais e pretenda receber doações de produtos que não tiveram procura para a vertente de consumo humano, inscreva-se aqui.",
  feedBank: "Food bank",
  horecaChannel: "HORECA channel",
  publicEntities: "Municipality / Parish Council",
  industry: "Industry",
  ipss: "IPSS",
  code: "Code",
  eventOrganization: "Event Organization",
  production: "Production",
  retailer: "Retailer",
  other: "Other",
  otherReceiver: "Other Entities with Social Purposes",
  groupUnitManangement: "I am an entity with several establishments",
  store: "I'm just an establishment",
  emailRequired: "Email is required",
  passwordRequired: "Password is required",
  pleaseRetypePassword: "Please retype password",
  passwordDonotMatch: "Passwords do not match",
  event: "Event",
  details: "Details",
  articles: "Articles",
  messages: "Messages",
  Messages: "Mensagens",
  collectionperiod: "Collection period",
  unread: "Unread",
  praesentiumWhenIRelease: "Praesentium when I Release",
  quisVelitCorporisIlloPorroPossimusVoluptasQuasiTenetur:
    "Quis velit corporis illo porro possimus voluptas quasi tenetur",
  veroWantedPraesentiumLabore: "Vero wanted praesentium labore",

  // Dashboard
  newDonation: "New Donation",
  history: "History",
  home: "Home",
  actions: "Agenda",
  settings: "Settings",
  createDonationHeading: "What are we going to donate today?",
  fightWaste: "I want to fight waste!",
  donate: "Donate",
  donateDescription: "I want to fight waste!",
  insertBySearch: "Insert by search",
  insertByBatch: "Insert by batches",
  search: "Search",
  needHelpWithProcess: "Need help with the process?",
  clickToTour: "Click to Tour",
  commonQuestions: "Common questions",
  messageAndNotification: "Messages and Notifications",
  alertAndNotification: "Alerts and Notifications",
  donationAvailable: "Donation available",
  scheduleAction: "Schedule action",
  donationDelivered: "Donation delivered",
  simpleStatThisMonth: "Simple stat this month",
  myOngoingDonations: "My ongoing donations",
  seeAll: "See all",
  myActivitySummary: "My activity summary",
  myActivitySummarySub: "Brief summary of donations placed on the platform",
  myAlerts: "My alerts",
  myAlertsSub: "Last Interactions",
  selectTypeOfDonation: "Select the type of donation to make",
  product: "Product",
  collection: "Collection",
  boxes: "Boxes",
  myProfile: "My Profile",
  addBranch: "Add Branch",
  manageBranches: "Establishments",
  //ByNishad
  houseHold: "Household",
  name: "Name",
  district: "District",
  county: "County",
  parshi: "Parish",
  contacts: "Contacts",
  contact: "Contact",
  postcard: "Postcard",
  locality: "Locality",
  continue: "Continue",
  addItem: "Add Item",

  // ------------------------------
  // Abhimanyu
  wrongPassOrEmailMsg: "Incorrect Email or Password",
  emailAddress: "Email Address",
  emailForAddress: "Email Address",
  createDonationAddressHeading: "Delivery place",
  myAddress: "My Address",
  otherAddresses: "Other addresses",
  mobile: "Mobile",
  designation: "Designation",
  readyMeals: "Ready Meals",
  fresh: "Fresh",
  observations: "Observations",

  //------------------------------
  // Parminder
  loginSuccess: "Logged in successfully!",
  finalize: "Finalize",
  addressTitle: "Address Title",
  contactName: "Contact Name",
  phone: "Phone",
  email: "Email",
  address: "Address",
  addProduct: "Add",
  unit: "unit",
  box: "box",
  kg: "kg",
  litre: "litre",
  pieces: "pieces",
  //dozen: "dozen",
  kl: "kl",
  //
  upComingCollection: "Up Coming Collection",
  collectionOfScheduledDonations: "Collection of Scheduled Dontaions",
  donations: "Donations",
  available: "Available",
  quantityIsRequired: "Quantity is Required",
  accept: "Accept",
  acceptedQuantity: "Qty:accepted",
  collectionDate: "Collection Date",
  //
  requestInActiveStatus:"Account disabled",
  requestStatus: "Request Status",
  rejectModalContent: `Your registration request has been rejected. Please contact support at ${SupportEmail} for any queries.`,
  pendingModalContent: `Your request has been registered and is under review. For any clarification, please contact us at the address: ${SupportEmail}.`,
  inActiveModalContent: `Your account has been disabled by the administrator. For any clarification, contact us at: ${SupportEmail}`,
  revokedModalContent: `Your registration has been deactivated. For any clarification, please contact us at the address: ${SupportEmail}`,
  pendingEmailVerificationContent:
    "Your email has not yet been confirmed. Please confirm your mailbox.",
  resetYourPassword: "Reset your password",
  enterNewPassword: "Enter New Password",
  confirmNewPasssword: "Enter Confirm New Password",
  passwordChanged: "Password Reset Successfully",
  passwordSuccessfullyChange:
    "Congratulations! Your password has been changed successfully.",
  goToHome: "Back to start",
  enterRegisteredEmail:
    "Enter your registered email address and we'll send you a password reset link",
  enterYourEmail: "Enter Your Email Address",
  sendPasswordResetEmail: "Send password reset email",
  resetPasswordLinkMessage:
    "We've sent you a password reset link. Please reset your password through the link.",
  accountVerficationSuccessful:
    "Congratulations! Your account has been successfully verified. You will be notified after approval by the platform administrator.",
  organizations: "Organizations",
  hello: "Hello",
  entity: "Entity",
  profileOptions: "Profile Options",
  primaryAddress: "Primary Address",
  contactDetail: "Contact Detail",
  pleaseEnterTheRegisteredEmail: "Please Enter the registered E-mail",
  pendingApplication: "Pending Application",
  allOrganizations: "All Organizations",
  totalDonations: "Total Donations",
  totalCollections: "Total Collections",
  companyType: "Company Type",
  lastActiveDate: "Last Active Date",
  noOfChild: "No of Child",
  id: "Id",
  action: "Action",
  dateOfApplication: "Date of application",
  branchName: "Branch Name",
  save: "Save",
  emailAlreadyExist: "Email already Exist",
  manageManagers: "Users",
  registrationSuccessfulMessage1:
    "Thank you for joining our food waste initiative! We have sent an email to your email address ",
  registrationSuccessfulMessage2: " with a link to confirm your registration.",
  noBranches: "There is no level 2 Entity",
  inviteManagerEmail: "User E-mail",
  invite: "Invite",
  inviteManager: "Invite User",
  status: "Status",
  edit: "Edit",
  editPrimaryContact: "Edit Primary Contact",
  contactDetailSuccessfullyUpdated: "Contact detail successfully updated",
  someThingWentWrong: "Something went wrong please try again later",
  addAddress: "Add Address",
  noAddressToShow: "No Address to show.",
  addresses: "Addresses",
  addContact: "Add Contact",
  noContactToShow: "No Contact to show",
  setYourPassword: "Set Your Password",
  passwordSuccessfullySave: "Password Successfully saved",
  accountAlreadyRegistered:
    "Your account is already registered with this email.please login",
  successfullyApproved: "Entity is successfully approved.",
  successfullyActivated: "Entity is successfully activated.",
  somethingWentWrong: "Something went wrong. please try after some time.",
  successfullyRejected: "Entity rejected successfully",
  successfullyDeactivated: "Entity Successfully Deactivated.",
  successfullyRevoked: "Manager Successfully Revoked",
  unableToUpdateAddress:
    "Unable to update entity address.please try again later.",
  successfullyUpdateAddress: "Address Updated Successfully.",
  successfullyAddedAddress: "Address added Successfully.",
  inviteSentSuccessfully: "Invitation Sent Successfully.",
  failedToUpdateDonation: "Failed to create donation.",
  donationCreatedSuccessfully: "Donation created successfully.",
  addContactSuccessfully: "Contact added Successfully.",
  successfullyReActive: "User Successfully Reactivated",
  businessRegistration: "Business Registration",
  BUSINESS_REGISTRATION: "Business Registration",
  MANDATED_STATEMENT: "Mandated statement",
  mandatedStatement: "Mandated statement",
  document: "Document",
  fileUploaded: "File is uploaded.",
  profileDetails: "Profile details",
  registrationEmail: "Registration Email",
  addressEmail: "Address E-mail",
  otherDetails: "Other Details",
  actionTakenOn: "Action Taken on",
  actionTakenBy: "Action Taken By",
  deactivate: "Deactivate",
  activate:"Activate",
  approved: "Approved",
  rejected: "Rejected",
  child: "child",
  selectAddress: "Select address to create donation",
  collectionCharacteristics: "Collection characteristics",
  dateCollection: "collection date",
  benificiaryEntity: "Beneficiary entity",
  remarks: "Remarks",
  postalCode: "Postal Code",
  restaurants: "Restaurants",
  hotel: "Hotel",
  catering: "Catering",
  type: "Type",
  groupEntity: "Description",
  group: "Group",
  singleEstablisment: "Establishment",
  viewDetails: "View Details",
  confirmationRejectContent:
    "Are you sure you want to reject the registration of this entity?",
  confirmationDeactivateContent:
    "Are you sure you want to deactivate this entity?",
  confirm: "confirm",
  startDate: "Start Date",
  endDate: "End Date",
  confirmRevokeUser: "Are you sure you want to revoke this User?",
  revoked: "Revoked",
  confirmationClearCart:
    "Are you sure you want to clear the entire donation list?",
  eventSub: "Special donation without (ex.: Weddings, Parties, etc.)",
  in: "in",
  until: "until",
  withdrawalDate: "withdrawal Date",
  youAreHere: "You are here",
  selectYourPosition: "Please, Mark your location in the map is required",
  getMyCurrentLocation: "Get my current Location",
  direction: "directions",
  category: "Category",
  filter: "Filter",
  toSave: "Save",
  collected: "Collected",
  cancelCollectionDialogTitle:
    "Are you sure you want to cancel this collection?",
  evaluateDonation: "Evaluate Donation",
  collectionCancelSuccess: "Collection cancelled successfully.",
  donationCancelledSuccessfully: "Donation cancelled successfully.",
  donationCollectedSuccessfully: "Donation collected successfully.",
  cancelDontaionDialogTitle: "Are you sure you want to cancel the donation?",
  orderBy: "Order by",
  list: "List",
  nearest: "Nearest",
  nearestExpiry: "Nearest Expiry",
  donationDonorSubHeading: "Consultation of offers",
  donationReceiverSubHeading: "Check available offers",
  distance: "Distance",
  toSee: "To See",
  all: "All",
  onlyFaviorate: "Only Faviorate",
  onlyAssigned: "Only Assigned",
  proximityOffers: "PROXIMITY OF OFFERS",
  offerDistance: "Offer Distances",
  location: "Location",
  setDistance: "Set the distance (Kms from the registration point)",
  selectLocation: "Select Location",
  selectProductError: "Please add products",
  selectAddressError: "Please, select the address",
  noOfReservation: "No of Reservations",
  myDonation: "My Donations",
  actives: "Active",
  reserved: "Reserved",
  donationExpireToday: `donations will expire today (click on “Order by” and then “Nearest ticket expiration date”)`,
  loading: "Loading...",
  collectionCollectedSuccess: "Collection collected successfully.",
  collectionFeedbackSuccessfully: "feedback submitted successfully.",
  expired: "Expired",
  profileSelectorHeading: "Select the Entity Type.",
  profileSelectorSubHeading: "What do you want to login as?",
  profileDonor: "Donor",
  profileDistributor: "Receiver",
  notificationFaviorateArtigoHeading: "Favorite article notifications",
  notificationFaviorateArtigoSubHeading:
    "Define the types of articles that interest you most",
  notificationFaviorateProximityHeading: "proximity notifications",
  notificationFaviorateProximitySubHeading:
    "Define when it will be agreed depending on the delivery location",
  noUpcomingCollections: "No donation scheduled",
  ongoingDonations: "Ongoing donations",
  collectionSelectionProductError:
    "The selection cannot exceed the available quantity",
  validDate: "Please Select valid date.",
  selectDate: "Please select the collection date.",
  collectionSelectProductError:
    "please select atleast one product for collection",
  unreadMessages: "Unread Messages",
  today: "Today",
  yesterday: "Yesterday",
  read: "Read",
  unRead: "Unead",
  lastMessageReceived: "Last Message Received to",
  noChat: "There no message is available.",
  sendMessage: "Send message",
  writeYourMessage: "Write your Message.",
  period: "Period",
  reservation: "Reservation",
  donationId: "Id",
  to: "to",
  pickupLocation: "Pickup Location",
  noCollectionForThisDonation: "There is no reservations for this donation.",
  noProductForThisDonation: "This is an event donation and has no products.",
  cancelled: "Cancelled",
  reservationCode: "Reservation Code",
  sweetDrop: "Sweet Drop",
  emptyCart: "Looks like your box is still empty",
  toGoBack: "To go Back",
  listOfItem: "List of item to donate",
  noRecordAvailable: "No Record Available",
  agendaArticles1: "This schedule has ",
  agendaArticles2: "item for collection.",
  noUpComingDistributorCollection: "No Scheduled pickup",
  collectionHistory: "Collection History",
  toMyrecentCollection: "To My recent close collection",
  noCollectionHistory: "No Collection History",
  viewMore: "View More",
  schedules: "schedules",
  alreadyVerifiedEmail: "This email has already been verified",
  collections: "Collections",
  noNotifications: "You have no Notifications.",
  notifications: "Notifications",
  unreadNotifications: "Unread Notifications.",
  cancelMotive: "Cancel Reason",
  collectionDoanationLoadingPhrase: "Wait. loading donations",
  subHeadingDonationDashboard: "Summary of most recent reservations",
  feedback: "Feedback",
  settingUpdatedSuccessfully: "Settings updated successfully",
  offers: "Offers",
  offerSubheading1: "There are",
  offerSubheading2: "more offers available, click below to see all",
  seeAllOffers: "See all offers",
  adminEntitiesLoadingPhrase: "Wait. loading entities",
  imageUpdate: "Image uploaded successfully",
  searchID: "Search ID",
  documentType: "Document type",
  documentName: "Document Link",
  expiryDate: "Expiry Date",
  WAITING_FOR_VALIDATION: "Waiting for validation",
  EXPIRED: "Expired",
  INVALID: "Inválido/Do not accept",
  VALID: "Valid",
  nameEstablishment: "Name Branch",
  documentUploadSuccessfully: "Upload the document successfully",
  upload: "Upload",
  mapInfo:
    "Define the point on the map to ensure the correct recording of the location",
  viewDocument: "View Document",
  documentValidSuccessfully: "Validate the document successfully ",
  documentRejectedSuccessfully: "Define Document is Rejected successfully ",
  confirmInvalidDocument:
    "Are you sure you want to invalidate/not accept this document?",
  specialDistributor:
    "I want to receive products from donations that have not been reserved – For animal feed...",
  specialDistributorBody:
    "All products entered on the Platform that have not been reserved and have reached the final validity of the ticket, can be sent for animal feed. If you are an entity with a mission / in the area of ​​protection / care for animals and want to receive donations of products that were not in demand for human consumption, sign up here.",
  zoo: "Zoo",
  ZOO: "Zoo",
  kennel: "Kennel / Cattery",
  KENNEL_CATTERY: "Kennel / Cattery",
  successfullyEstablishmentoActivated: "Establisment successfully activated",
  successfullyEstablishmentoDeactivated:
    "Establisment successfully Deactivated",
  delete: "Delete",
  deleteAddressContent: "Are you sure you want to delete the address ?",
  activeDonorAddress:
    "You cannot delete this address, there are ongoing donations",
  activeReceiverAddress:
    "You cannot delete this address, there are ongoing donations",
  successfullyAddressDeleted: "Your address is successfully deleted",
  alternativeAnimalChannel: "Allow alternate channel",
  invalidDate: "Invalid date",
  activeAltenativeCanal: "Active alternate channel",
  reservedAltenativeCanal: "Reservation alternate channel",
  alternativeChannelEndDate: "Alternative channel end date",
  permitted:"Allow",
  notPermitted:"Is not Allow",
  alternativeChannelHabilito:"Alternative Channel Enabled",
  offerAvialable:"Offer available",
  offerEnable: "Habilitadas",
  entityFavorite:"Entity Favorite",
  noEntites:"There has no entity",
  typeToSearch:"Type to search",
  consult:"Consult",
  donationNotAviableForExcludedEntities:"Donation not available for excluded entities",
  excludedEntites:"Entidades excluídas",
  beneficiaryEntites:"Entidades beneficiárias",
  noExcludedEntites: "Não tem entidade excluídas",
  statusInActiveInfo:"Pending validation if motive is required",
  statusRejectorInfo:"Pending validation if motive is required",
  noOptionsText:"No options",
  parentEntityNoDonation:"Your establishments do not have donations yet",
  childEntityNoDonation:"No donations yet. Click New Donation to get started",
  inviteManagerSuccess:"User invited successfully",
  errorMessage:"error",
  companyName:"Name",
  accountDisabled:"Account disabled. Contact your manager.",
  loginConfirm:"Confirm",
  branchAddedSuccessfulMessage: "Branch added successfully",

  /// notificacoes por mensagem 
  IsFimDoacao : "Fim de doação",
  IsNovaMensagem: "Nova mensagem",
  IsNovaReserva: "Nova reserva",
  IsReservaCancelada: "Reserva cancelada",
  IsArtigosFavoritos: "Artigos favoritos",
  IsDoacaoCancelada: "Doação cancelada",
  IsProximo: "Notificações de proximidade",
  isNewAlternativeDonation: "Nova doação para alimentação animal",
  IsEntidadeBeneficiaria: "Doações atribuídas"
};
